var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.451,
    height: 15.451,
    viewBox: "0 0 15.451 15.451",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16667",
    "data-name": "Rectangle 16667",
    width: 15.451,
    height: 15.451,
    fill: "#1ebcc2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16662",
    "data-name": "Group 16662",
    transform: "translate(4750 893.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16042",
    "data-name": "Group 16042",
    transform: "translate(-4750 -893.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16041",
    "data-name": "Group 16041",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41389",
    "data-name": "Path 41389",
    d: "M145.711,4.531q0,1.636,0,3.273A1.135,1.135,0,0,1,144.5,9.019q-2.323,0-4.645,0a1.14,1.14,0,0,1-1.223-1.226q0-3.28,0-6.561A1.137,1.137,0,0,1,139.861,0h4.63a1.132,1.132,0,0,1,1.22,1.224q0,1.652,0,3.3",
    transform: "translate(-130.261 -0.004)",
    fill: "#1ebcc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41390",
    "data-name": "Path 41390",
    d: "M0,111.12q0-1.651,0-3.3a1.132,1.132,0,0,1,1.2-1.2q2.345,0,4.691,0a1.132,1.132,0,0,1,1.193,1.194q0,3.311,0,6.621a1.132,1.132,0,0,1-1.2,1.2H1.2A1.128,1.128,0,0,1,0,114.438q0-1.659,0-3.318",
    transform: "translate(-0.004 -100.18)",
    fill: "#1ebcc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41391",
    "data-name": "Path 41391",
    d: "M142.156,175.773h-2.337a1.132,1.132,0,0,1-1.2-1.2q0-1.372,0-2.745a1.137,1.137,0,0,1,1.21-1.208q2.33,0,4.66,0a1.134,1.134,0,0,1,1.214,1.217q0,1.365,0,2.73a1.13,1.13,0,0,1-1.208,1.206h-2.337",
    transform: "translate(-130.251 -160.323)",
    fill: "#1ebcc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41392",
    "data-name": "Path 41392",
    d: "M3.551,0H5.888a1.13,1.13,0,0,1,1.2,1.189q0,1.387,0,2.775A1.131,1.131,0,0,1,5.9,5.152q-2.36,0-4.72,0A1.129,1.129,0,0,1,0,3.961Q0,2.574,0,1.186A1.127,1.127,0,0,1,1.183,0Q2.367,0,3.551,0",
    transform: "translate(0 0)",
    fill: "#1ebcc2"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard_icon.eba0d9763cc902584e744ce68fb8369f.svg";
export { ForwardRef as ReactComponent };